import request from "@/untils/request.js";
//赛事-预约
export function matchAddbooking(data) {
  return request({
    url: "/match/booking/create",
    method: "post",
    data,
  });
}
//赛事-取消预约
export function matchCancelbooking(params) {
  return request({
    url: "/match/booking/delete",
    method: "post",
    params,
  });
}
//赛事-收藏
export function addCollect(data) {
  return request({
    url: "/match/follow/create",
    method: "post",
    data,
  });
}
//赛事-取消收藏
export function cancelCollect(data) {
  return request({
    url: "/match/follow/delete",
    method: "post",
    data,
  });
}
//获取本场赛事直播列表
export function matchLiveList(params) {
  //matchId   type  1-足球 2-篮球
  return request({
    url: "/live/list-match",
    method: "get",
    params,
  });
}
